ceregoCommon.factory('ImagesResource', ['$resource', ($resource) ->
  $resource "",{},
    create:
      method: 'POST'
      isArray: false
      url: APIRoutes.v2_images_path()
])
